<template>
    <div id="map-card">
      <div class="map-left">
        <div class="select-box">
          <a-checkbox-group>
            <a-row :gutter="[0,16]">
              <a-col :span="24">
                <a-checkbox value="recycleCar">
                  <span style="font-size: 1em;color: #FFFFFF;">上门回收车辆</span>
                </a-checkbox>
              </a-col>
              <a-col :span="24">
                <a-checkbox value="wingRoom">
                  <span style="font-size: 1em;color: #FFFFFF;">定点厢房</span>
                </a-checkbox>
              </a-col>
              <a-col :span="24">
                <a-checkbox value="transitCar">
                  <span style="font-size: 1em;color: #FFFFFF;">中转车辆</span>
                </a-checkbox>
              </a-col>
              <a-col :span="24">
                <a-checkbox value="administrative">
                  <span style="font-size: 1em;color: #FFFFFF;">行政楼</span>
                </a-checkbox>
              </a-col>
              <a-col :span="24">
                <a-checkbox value="dealStand">
                  <span style="font-size: 1em;color: #FFFFFF;">处理站</span>
                </a-checkbox>
              </a-col>
              <a-col :span="24">
                <a-checkbox value="transitStand">
                  <span style="font-size: 1em;color: #FFFFFF;">中转站</span>
                </a-checkbox>
              </a-col>
            </a-row>

          </a-checkbox-group>
        </div>
        <dv-decoration-2 :reverse="true" style="width:5px;height:99%;position: absolute;top: 0.5%;left: 14.9%;" />
      </div>
      <div class="map-right">
        <iframe class="map" :src="srcStr" frameborder="0"></iframe>
      </div>
      <input id="code" type="hidden" :value="streetId"/>
    </div>
</template>

<script>

  export default {
    name: "BottomMap2",
    components: {},
    props: ['play'], // 接受父级传递的数据
    data(){
      return{
        srcStr: '',
        streetId: 0
      }
    },
    methods: {
      createData(){
        let streetId = this.$store.state.account.user.streetId;
        this.streetId = streetId;
        this.srcStr = '/static/villagemap/index.html';
      },
      audioPlay: function () {
        this.$emit('playStatus',false); // 向父级组件传递参数
      }
    },
    watch: { // 监听数据 如果改变执行audioPlay函数，audioPlay在methods中定义
      play: 'audioPlay'
    },
    mounted() {
      const {createData} = this;
      createData();

      window.addEventListener('message', (eve) => {
        if(eve.name != undefined){
          console.log(eve.name);
        }
      });
    },
    destroyed() {
      window.removeEventListener('message', (eve) => {
        if(eve.name != undefined){
          console.log(eve.name);
        }
      },true);
    }
  }
</script>

<style lang="less" scoped>
  #map-card{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 5px;

    .map-left{
      width: 15%;
      height: 100%;
      padding: 5px;
    }

    .map-right{
      width: 85%;
      height: 100%;
    }

    .select-box{
      margin-top: 50%;
    }

    .map{
      width: 880px;
      height: 559px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/datav/BottomMap2.vue